<!-- Form radio option rendered as a selectable button rather than a radio dot. -->

<script lang="ts" setup generic="T extends Primitive = Primitive">
import type { Primitive } from '@nzyme/types/Common.js';
import { getRadioEmits, getRadioProps, useRadio } from '@nzyme/vue-forms/components/useRadio.jsx';
import type { Slots } from '@nzyme/vue-utils/slots.js';

import { ButtonInputProps, getButtonInputClass } from './ButtonInput';

interface RadioButtonSlots {
  default: { selected: boolean };
}

const props = defineProps({
  ...getRadioProps<T>(),
  ...ButtonInputProps,
});
defineSlots<Slots<RadioButtonSlots>>();
defineEmits(getRadioEmits<T>());

const { Radio, state } = useRadio<T>(props);
</script>

<template>
  <Radio :class="getButtonInputClass(props, state.selected)">
    <slot :selected="state.selected" />
  </Radio>
</template>

<style lang="scss" module="css" src="./ButtonInput.module.scss" />
